import React, { Component } from 'react'
import Modal from 'react-modal'
import RestApiUtils from '../../../../apiclient/moebli/RestApiUtils.js'
import RepaymentPrincipalModalUI from './RepaymentPrincipalModalUI.js'

class RepaymentPrincipalModalSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      successMsg: null,
      errorList: null,
      submitted: false,
      status: null,
      principalAmount: this.props.selectedRepayment ? this.props.selectedRepayment.principalAmountF : '',
      principalAmountError: null,
    }
  }

  render() {
    return (
      <RepaymentPrincipalModalUI
        context={this.props.context}
        errorList={this.state.errorList}
        successMsg={this.state.successMsg}
        setErrorList={this.setErrorList}
        // modes
        updateMode={this.props.updateMode}
        submitted={this.state.submitted}
        status={this.state.status}
        // event handlers
        onSubmit={this.onSubmit}
        onCancelClick={this.onCancelClick}
        // form fields
        principalAmount={this.state.principalAmount}
        onPrincipalAmountChange={(event) => { this.setState({ principalAmount: event.target.value }) }}
        principalAmountError={this.state.principalAmountError}
        setPrincipalAmountError={(error) => { this.setState({ principalAmountError: error }) }}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    Modal.setAppElement('body')
  }

  componentDidUpdate(prevProps) {
    let repayment = this.props.selectedRepayment
    if (!repayment ||
      prevProps.selectedRepayment && prevProps.selectedRepayment.scheduledDate === repayment.scheduledDate)
      return

    if (repayment.status == 'paid' || repayment.status == 'initiated') {
      this.setState({
        status: repayment.status,
        submitted: false,
        errorList: null
      })
    }

    if (repayment.status == 'unpaid') {
      this.setState({
        principalAmount: '',
        status: repayment.status,
        submitted: false,
        errorList: null
      })
    }
  }

  onSubmit = () => {
    let submitted = this.state.submitted
    if (submitted)
      return

    this.setState({
      successMsg: null,
      errorList: [],
      submitted: true
    })

    RestApiUtils.put(this.props.context,
      `/api/su/loans/${this.props.loan.loanId}/repayments/scheduledDates/${this.props.selectedRepayment.scheduledDateISO}/principalAdjusted/pay`,
      this.onSubmitCallback, {
      principalAdjustedF: this.state.principalAmount
    }
    )
  }

  onSubmitCallback = (response) => {
    let errorList = []
    response.errorList.forEach(error => {
      errorList.push(error.message)
    })

    this.setState({
      successMsg: response.success,
      errorList: errorList,
      submitted: false
    })

    if (response.errorList.length === 0) {
      setTimeout(() => {
        this.setState({
          successMsg: null
        })
        this.props.onCancelClick()
        this.props.onRefreshClick('noBusy')
      }, 100)
    }
  }

  onCancelClick = () => {
    this.setState({
      errorList: null,
      submitted: false,
    })
    this.props.onCancelClick()
  }

  setErrorList = (errorList) => {
    this.setState({ errorList: errorList })
  }
}

export default RepaymentPrincipalModalSF
